/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sklik_ValueInputs */

const cs_sklik_value = /** @type {(inputs: Sklik_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hodnota leadu (Kč)`)
};

const en_sklik_value = /** @type {(inputs: Sklik_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead value (CZK)`)
};

/**
* | output |
* | --- |
* | "Lead value (CZK)" |
*
* @param {Sklik_ValueInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sklik_value = /** @type {((inputs?: Sklik_ValueInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sklik_ValueInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sklik_value(inputs)
	return cs_sklik_value(inputs)
});